import React, { useEffect, useState } from "react";
import "./tablebody.css";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  TableCell,
  PaginationItem,
  Typography,
  Box,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DvrIcon from "@mui/icons-material/Dvr";
import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {
  handleToast,
  isAudioFile,
  isImageURL,
  isValuePresent,
} from "../../utils";
import Chip from "@mui/material/Chip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import { RiNotificationLine } from "react-icons/ri";
import { RiNotificationOffLine } from "react-icons/ri";
import {
  handle_Active,
  // handleStatus,
  handleUpdateAudioStatus,
  update_consultant,
} from "../../services/api/consultant";
import Pop from "../Audio Type/RecordingPop";
import ItemBoxList from "./Itembox";
import { handleCredentialsStatus } from "../../services/api/application";
import {
  handleAdminPassword,
  handleDeleteApi,
  handleSubAdminPassword,
  // handleUpdateAdminStatus,
  update_Admin,
  updateSubAdmin,
} from "../../services/api/admin";
import {
  // handleuserStatus,
  update_User,
} from "../../services/api/users";
import { toast } from "react-toastify";
import AdminPasswordModal from "../Global/AdminPasswordModal";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Padding } from "@mui/icons-material";
import PaginationUI from "./PaginationUI";
import { consultant } from "../../services/config";
// import { cleanFilterItem } from "@mui/x-data-grid/hooks/features/filter/gridFilterUtils";

export default function TableBody2({
  headers,
  APIdata,
  cell,
  path,
  data,
  notfound,
  loader,
  menu,
  setReload,
  setSkip,
  total,
  setLimit,
  // eslint-disable-next-line
  pages,
  disabled,
  deleted,
  handleDeleted,
  newPage = {},
  credentialsData,
  activete_data,
  isDisabled,
  apiDelete = false,
  reset = false,
  approve_status,
  search,
  getStatusChip,
  IsAction = true,
  // Custom action menu items rendered after the standard Delete row. Each entry
  // is { label, icon?, onClick(row), disabled?, danger? }. Used by the Users
  // list to expose Soft Delete + Hard Delete side-by-side.
  extraMenuItems,
}) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showdata, setShowData] = useState([]);
  const [data_id, setData_id] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState(false);
  const [balance_data, setBalance_data] = useState("");
  const [Consultant_name, setConsultant_name] = useState("");
  const [BankPk, setBankpk] = useState("");
  const [BankSk, setBankSk] = useState("");
  const [data2_id, setDat2_id] = useState("");
  const [disable, setDisable] = useState(false);
  const isMobile = window.innerWidth <= 600;
  const [openReset, setOpenReset] = useState(false);
  const [password, setPassword] = useState("");
  const [showdata2, setShowData2] = useState([]);
  const localData = JSON.parse(localStorage.getItem("data"));
  const location = useLocation();

  useEffect(() => {
    if (loader) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [loader]);

  useEffect(() => {
    setPage(1);
  }, [approve_status, search]);

  useEffect(() => {
    setPage(1);
  }, []);

  useEffect(() => {
    const rows = JSON.parse(sessionStorage.getItem("rowsperpage"));
    const Limit = JSON.parse(sessionStorage.getItem("Limit"));
    const value = JSON.parse(sessionStorage.getItem("newPage"));
    if (rows || Limit || value) {
      if (rows) {
        setRowsPerPage(rows || 5);
      } else {
        setRowsPerPage(5);
      }

      if (rows) {
        setLimit(rows);
      } else {
        setLimit(5);
      }

      if (page) {
        setPage(JSON.parse(value));
        newPage.current = value;
      } else {
        newPage.current = 1;
        setPage(1);
      }
    } else {
      setRowsPerPage(5);
      setLimit(5);
      newPage.current = 1;
      setPage(1);
    }
  }, [location, pages]);

  const open = Boolean(anchorEl);
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
    sessionStorage.setItem("path", JSON.stringify(location.pathname));
  };

  const handleClose = () => {
    setAnchorEl(null);

    setSelectedRow(null);
  };

  const handleChangePage = (e, value) => {
    setPage(value);
    newPage.current = value;
    sessionStorage.setItem("newPage", value);
    setSkip((value - 1) * rowsPerPage);
    setReload((data) => !data);
  };

  const handlePrev = () => {
    if (page > 1) {
      const newPageValue = page - 1;

      // Frontend update
      setPage(newPageValue);
      newPage.current = newPageValue;
      sessionStorage.setItem("newPage", newPageValue);

      // Backend skip calculation
      const newSkip = (newPageValue - 1) * rowsPerPage;
      setSkip(newSkip);

      // Trigger reload
      setReload((prev) => !prev);

      console.log("User clicked Prev");
      console.log("Frontend page:", newPageValue);
      console.log("Backend skip:", newSkip);
    }
  };

  const handleNext = () => {
    const newPageValue = page + 1;

    // Frontend update
    setPage(newPageValue);
    newPage.current = newPageValue;
    sessionStorage.setItem("newPage", newPageValue);

    // Backend skip calculation
    const newSkip = (newPageValue - 1) * rowsPerPage;
    setSkip(newSkip);

    // Trigger reload
    setReload((prev) => !prev);

    console.log("User clicked Next");
    console.log("Frontend page:", newPageValue);
    console.log("Backend skip:", newSkip);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    sessionStorage.setItem("rowsperpage", event.target.value);
    sessionStorage.setItem("Limit", event.target.value);
    setLimit(event.target.value);
    newPage.current = 1;
    sessionStorage.setItem("newPage", 1);
    setSkip(0);
    setPage(1);
  };

  const handlefunction = async (id, status) => {
    try {
      handleUpdateAudioStatus(id, status)
        .then(() => {})
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
    setReload((prev) => !prev);
  };
  const handlechange = async (status, person) => {
    const body = {
      ...person,
      approve_status: status,
    };

    try {
      update_consultant(body)
        .then(() => {
          toast.success(`Consultant ${status} successfully`, {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
    setReload((prev) => !prev);
  };

  const handleActive = async (activate, person, type) => {
    const data = {
      id: person?.id || "",
      role: person?.role || "",
      activate: activate,
      SK: person?.SK || "",
      PK: person?.PK || "",
    };

    const consultant = {
      ...person,
      active: activate,
    };

    setReload((prev) => !prev);
    try {
      type == "Consultant"
        ? update_consultant(consultant)
        : handle_Active(data)
            .then(() => {
              toast.success(
                `Consultant  ${activate ? "activated" : "deactivated"} successfully`,
                {
                  position: isMobile ? "top-left" : "top-center",
                  style: {
                    width: isMobile ? "300px" : "400px",
                    textWrap: isMobile && "wrap",
                  },
                },
              );
            })
            .catch((error) => {
              handleToast(error?.response?.data);
              return;
            });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
  };

  const handleCredentials = (status, person) => {
    const data = {
      status: status.toString(),
      id: person.id,
      // SK: SK,
      // PK: PK,
    };
    try {
      handleCredentialsStatus(data)
        .then(() => {
          toast.success(
            `Credentials ${status ? "activated" : "deactivated"} successfully`,
            {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            },
          );
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
    setReload((prev) => !prev);
  };

  const handleAdminUpdate = async (person, activate) => {
    const data = {
      ...person,
      active: activate,
    };

    try {
      (person.entity === "admin" ? update_Admin(data) : updateSubAdmin(data))
        .then(() => {
          toast.success(
            `Admin ${activate ? "activated" : "deactivated"} successfully`,
            {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            },
          );
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
    setReload((prev) => !prev);
  };

  const handleOpen = (data, id) => {
    setOpenPopup(true);
    setShowData(data);
    setData_id(id);
  };
  const handleopenModal = (data, name, id) => {
    setCredentials(true);
    setOpenPopup(true);
    setBalance_data(data);
    setConsultant_name(name);
    setDat2_id(id);
  };

  const handleOpen2 = (data, sk, pk, credential) => {
    setOpenPopup(true);
    setCredentials(credential);
    setShowData(data);
    setBankSk(sk);
    setBankpk(pk);
  };

  const handleUserStatus = async (status, person) => {
    const form = {
      id: person?.id,
      active: status,
    };
    setReload((prev) => !prev);
    try {
      // handleuserStatus(form)
      update_User(form)
        .then(() => {
          setReload((prev) => !prev);
          toast.success(
            `User ${status ? "activated" : "deactivated"} successfully`,
            {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            },
          );
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
  };

  const handleDelete = async (id, type) => {
    setReload((prev) => !prev);
    try {
      handleDeleteApi(id, null)
        .then(() => {
          toast.success("Deleted Successfully", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
          setReload((prev) => !prev);
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
    }
  };

  const handleResetPassword = (data, id) => {
    setReload((prev) => !prev);
    setShowData2([data]);
    const form = {
      id: id,
    };
    try {
      (data.entity === "sub_admin"
        ? handleSubAdminPassword(form)
        : handleAdminPassword(form)
      )
        .then((response) => {
          toast.success("Password Reset Successfully", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
          setPassword(response?.data?.data?.password);
          setOpenReset(true);
          setReload((prev) => !prev);
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
    }
  };

  return (
    <div className="table">
      <div className="table-main-top">
        <TableContainer
          component={Paper}
          style={{
            boxShadow: "none",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Table>
            <TableHead>
              <TableRow className="tablebody-con">
                {headers?.map((header) => {
                  return (
                    <TableCell
                      className="tablecell-con"
                      align="center"
                      key={header.topic}
                      sx={{
                        width: "fit-content",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {header.topic}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                //  APIdata.slice((page-1) * rowsPerPage , (page-1) * rowsPerPage + rowsPerPage)
                APIdata?.map((person, x) => {
                  return (
                    <TableRow key={x} className="tablebody-con">
                      <TableCell className="tablecell-con" align="center">
                        {(page - 1) * rowsPerPage + (x + 1)}
                      </TableCell>
                      {cell?.map((topic, y) => {
                        return (
                          <TableCell
                            key={y}
                            className="tablecell-con"
                            align="center"
                          >
                            {(() => {
                              const value = person[topic.topic];
                              const date = new Date(person?.created_at || "");

                              const formattedDate = date.toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                },
                              );
                              if (topic.topic === "consultant#name") {
                                return person?.consultant?.name || "NA";
                              }
                              if (topic.topic === "consultant#id") {
                                return person?.consultant?.id || "NA";
                              }

                              if (topic.topic === "consultant#email") {
                                return person?.consultant?.email || "NA";
                              }

                              if (topic.topic === "service") {
                                return person?.service?.name || "NA";
                              }
                              if (topic.topic == "created_at") {
                                return formattedDate || "NA";
                              }
                              if (topic.topic === "created_at_time") {
                                if (person.created_at) {
                                  const time = new Date(
                                    person.created_at,
                                  ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  });
                                  return time;
                                } else {
                                  return "NA";
                                }
                              }
                              if (topic.topic === "consultant.name") {
                                return person?.consultant?.name || "NA";
                              }

                              if (topic.topic === "consultant.id") {
                                return person?.consultant?.id || "NA";
                              }

                              if (topic.topic === "consultant.email") {
                                return person?.consultant?.email || "NA";
                              }
                              if (topic.topic == "user.name") {
                                return person?.user?.name || "NA";
                              }
                              if (topic.topic == "user.email") {
                                return person?.user?.email || "NA";
                              }
                              if (topic.topic == "user.role") {
                                return person?.user?.role || "NA";
                              }
                              if (topic.topic == "amount_data") {
                                if (
                                  person.transaction_type === "deducted" &&
                                  person.amount
                                ) {
                                  return (
                                    <span style={{ color: "red" }}>
                                      {" "}
                                      -₹{person.amount}
                                    </span>
                                  );
                                } else if (
                                  person.transaction_type === "added" &&
                                  person.amount
                                ) {
                                  return (
                                    <span style={{ color: "green" }}>
                                      +₹{person.amount}
                                    </span>
                                  );
                                } else {
                                  return "NA";
                                }
                              }
                              if (topic.topic === "status_transaction") {
                                return person.status
                                  ? getStatusChip(person.status)
                                  : "NA";
                              }
                              if (topic.topic === "recharge_amount_box") {
                                return (
                                  <Chip
                                    label="Recharge"
                                    color="success"
                                    variant="contained"
                                    disabled={
                                      (person?.approve_status &&
                                        (person?.approve_status).toLowerCase() ===
                                          "rejected") ||
                                      (person?.approve_status &&
                                        (person?.approve_status).toLowerCase() ===
                                          "pending") ||
                                      person.active === false ||
                                      person?.deleted_at
                                        ? true
                                        : false
                                    }
                                    style={{
                                      fontSize: "0.7rem",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      handleOpen2(
                                        person,
                                        person.name,
                                        person.id,
                                        "recharge_open",
                                      );
                                    }}
                                  />
                                );
                              }
                              if (topic.topic == "bank_account_details") {
                                return (
                                  <VisibilityIcon
                                    style={{ color: "#f99234" }}
                                    onClick={() => {
                                      handleOpen2(
                                        person.bank_account_details,
                                        person.SK,
                                        person.PK,
                                        "approve_bank",
                                      );
                                    }}
                                  />
                                );
                              }
                              if (topic.topic == "openBox") {
                                return (
                                  <VisibilityIcon
                                    onClick={() =>
                                      handleOpen(
                                        person.pending_recordings,
                                        person.id,
                                      )
                                    }
                                  />
                                );
                              }
                              if (topic.topic == "permissions") {
                                return <ItemBoxList items={value} />;
                              }
                              if (topic.topic === "languages") {
                                return `Length : ${JSON.stringify(
                                  person?.languages?.length,
                                )}`;
                              } else if (
                                topic.topic === "main_call_charges_per_minute"
                              ) {
                                return (
                                  person?.main_call_charges_per_minute?.toString() ||
                                  "NA"
                                );
                              } else if (
                                topic.topic === "chat_charges_per_message"
                              ) {
                                return (
                                  person?.chat_charges_per_message?.toString() ||
                                  "NA"
                                );
                              } else if (
                                topic.topic === "call_charges_per_minute"
                              ) {
                                return (
                                  person?.call_charges_per_minute?.toString() ||
                                  "NA"
                                );
                              } else if (topic.topic === "consultant") {
                                if (topic.topic) {
                                  return person?.consultant?.name || "NA";
                                } else if (person.consultant.length === 0) {
                                  return "NA";
                                }
                              } else if (
                                isImageURL(value) ||
                                topic.topic === "photo"
                              ) {
                                if (value) {
                                  return (
                                    <img
                                      src={value}
                                      alt="Avtar"
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "20px",
                                        border: "1px solid black",
                                      }}
                                    />
                                  );
                                } else {
                                  return "NA";
                                }
                              }

                              // Show "NA" if data is missing or empto
                              if (
                                value === null ||
                                value === undefined ||
                                value.length === 0
                              ) {
                                return "NA";
                              } else if (
                                topic.topic === "last_settlement_date"
                              ) {
                                const date = new Date(
                                  person?.last_settlement_date || "",
                                );

                                const formattedDate = date.toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  },
                                );
                                return formattedDate;
                              } else if (
                                (topic.topic === "activate" &&
                                  typeof value === "boolean") ||
                                topic.topic == "active"
                              ) {
                                return (
                                  <Chip
                                    label={JSON.stringify(value)}
                                    color="warning"
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "gray",
                                      border: "2px solid  white",
                                      color: "white",
                                    }}
                                  />
                                );
                              } else if (
                                typeof value === "boolean" ||
                                topic.topic === "is_default" ||
                                topic.topic === "is_popular"
                              ) {
                                return JSON.stringify(value);
                              } else if (topic.topic === "consultant_id") {
                                return person.consultant_id.name;
                              } else if (topic.topic === "consultant_type") {
                                const value2 = value["name"];
                                return value2;
                              } else if (topic.topic === "audio_type") {
                                const value3 = value["name"];
                                return value3;
                              } else if (typeof value === "number") {
                                return value;
                              } else if (value instanceof Array) {
                                return value?.join(", ") || "NA";
                              } else if (isAudioFile(value)) {
                                return (
                                  <audio controls className="recording">
                                    {" "}
                                    <source src={value} />
                                  </audio>
                                );
                              } else if (
                                value === "pending" ||
                                value === "Pending"
                              ) {
                                return (
                                  <Chip
                                    label={value}
                                    color="warning"
                                    variant="outlined"
                                  />
                                );
                              } else if (
                                value === "approved" ||
                                value === "Approved"
                              ) {
                                return (
                                  <Chip
                                    label={value}
                                    color="success"
                                    variant="outlined"
                                  />
                                );
                              } else if (
                                value === "rejected" ||
                                value === "Rejected"
                              ) {
                                return (
                                  <Chip
                                    label={value}
                                    color="error"
                                    variant="outlined"
                                  />
                                );
                              } else if (isValuePresent(value)) {
                                return value;
                              } else {
                                return value;
                              }
                            })()}
                          </TableCell>
                        );
                      })}
                      {IsAction && (
                        <TableCell className="tablecell-con" align="center">
                          {menu === "balance" ? (
                            <Chip
                              label="Transfer Funds"
                              color="success"
                              variant="contained"
                              style={{ fontSize: "0.7rem", cursor: "pointer" }}
                              onClick={() => {
                                sessionStorage.setItem(
                                  "path",
                                  JSON.stringify(location.pathname),
                                );
                                handleopenModal(
                                  person.balance,
                                  person.name,
                                  person.id,
                                );
                              }}
                            />
                          ) : menu == "bank" ? (
                            <VisibilityIcon
                              onClick={() => {
                                handleOpen2(
                                  person.pending_details,
                                  person.consultant.id,
                                  person.PK,
                                  "bank",
                                );
                                sessionStorage.setItem(
                                  "path",
                                  JSON.stringify(location.pathname),
                                );
                              }}
                            />
                          ) : menu == "transaction" ? (
                            <VisibilityIcon
                              disabled
                              style={{
                                color: "#1c1c1c54",
                              }}
                            />
                          ) : (
                            <Button
                              id={`button-${person.id}`}
                              aria-controls={
                                open && selectedRow?.id === person.id
                                  ? `menu-${person.id}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                open && selectedRow?.id === person.id
                                  ? "true"
                                  : undefined
                              }
                              onClick={(event) => handleClick(event, person)}
                            >
                              <MoreVertIcon style={{ color: "black" }} />
                            </Button>
                          )}
                          {}

                          {menu && (
                            <Menu
                              id={`menu-${person.id}`}
                              anchorEl={anchorEl}
                              open={open && selectedRow?.id === person.id} // Ensure only the clicked row's menu opens
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `button-${person.id}`,
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  navigate(path, {
                                    state: { data: person, edit2: true },
                                  });
                                }}
                              >
                                <DvrIcon style={{ marginRight: "5px" }} /> Show
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  navigate(path, {
                                    state: { data: person, edit2: false },
                                  });
                                }}
                                disabled={disabled}
                              >
                                {" "}
                                <DriveFileRenameOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                Edit
                              </MenuItem>

                              {(person.active ||
                                !person.active ||
                                person.active === "true" ||
                                !person.active === "false") &&
                                isDisabled === "status" && (
                                  <>
                                    {person.active ||
                                    person.active === "true" ? (
                                      <MenuItem
                                        onClick={() => {
                                          handleUserStatus(
                                            // person.id,
                                            // person.role,
                                            false,
                                            person,
                                            // person.PK
                                          );
                                          handleClose();
                                        }}
                                      >
                                        <RiNotificationOffLine
                                          style={{ marginRight: "5px" }}
                                        />
                                        Deactivate
                                      </MenuItem>
                                    ) : (
                                      <MenuItem
                                        onClick={() => {
                                          handleUserStatus(
                                            // person.id,
                                            // person.role,
                                            true,
                                            person,
                                            // person.PK
                                          );
                                          handleClose();
                                        }}
                                      >
                                        <RiNotificationLine
                                          style={{ marginRight: "5px" }}
                                        />
                                        Activate
                                      </MenuItem>
                                    )}
                                  </>
                                )}
                              {activete_data === true && (
                                <>
                                  {person.status && person.status == "true" ? (
                                    <MenuItem
                                      onClick={() => {
                                        handleCredentials(
                                          false,
                                          person,
                                          // person.PK
                                        );
                                        handleClose();
                                      }}
                                    >
                                      <RiNotificationOffLine
                                        style={{ marginRight: "5px" }}
                                      />
                                      Deactivate
                                    </MenuItem>
                                  ) : (
                                    <MenuItem
                                      onClick={() => {
                                        handleCredentials(
                                          true,
                                          person,
                                          // person.PK
                                        );
                                        handleClose();
                                      }}
                                    >
                                      <RiNotificationLine
                                        style={{ marginRight: "5px" }}
                                      />
                                      Activate
                                    </MenuItem>
                                  )}
                                </>
                              )}
                              {activete_data === "true" && (
                                <>
                                  {person.active ? (
                                    <MenuItem
                                      onClick={() => {
                                        handleAdminUpdate(person, false);
                                        handleClose();
                                      }}
                                    >
                                      <RiNotificationOffLine
                                        style={{ marginRight: "5px" }}
                                      />
                                      Deactivate
                                    </MenuItem>
                                  ) : (
                                    <MenuItem
                                      onClick={() => {
                                        handleAdminUpdate(person, true);
                                        handleClose();
                                      }}
                                    >
                                      <RiNotificationLine
                                        style={{ marginRight: "5px" }}
                                      />
                                      Activate
                                    </MenuItem>
                                  )}
                                </>
                              )}
                              {(person.entity === "admin" ||
                                person.entity == "sub_admin") &&
                                reset &&
                                localData.entity == "super_admin" && (
                                  <MenuItem
                                    onClick={() => {
                                      handleResetPassword(
                                        person,
                                        person.id,
                                        "sub_admin",
                                      );
                                      handleClose();
                                    }}
                                  >
                                    <RestartAltIcon
                                      style={{ marginRight: "5px" }}
                                    />
                                    Reset Password
                                  </MenuItem>
                                )}
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  {
                                    apiDelete
                                      ? handleDelete(person.id, person.entity)
                                      : handleDeleted(person.id);
                                  }
                                }}
                                disabled={deleted}
                              >
                                {" "}
                                <DeleteOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                Delete
                              </MenuItem>
                              {Array.isArray(extraMenuItems) &&
                                extraMenuItems.map((it, ix) => (
                                  <MenuItem
                                    key={`extra-${person.id}-${ix}`}
                                    onClick={() => {
                                      handleClose();
                                      it.onClick?.(person);
                                    }}
                                    disabled={it.disabled}
                                    sx={
                                      it.danger
                                        ? { color: "#dc2626" }
                                        : undefined
                                    }
                                  >
                                    {it.icon ? (
                                      <span style={{ marginRight: "5px", display: "inline-flex" }}>
                                        {it.icon}
                                      </span>
                                    ) : (
                                      <DeleteOutlineIcon
                                        style={{ marginRight: "5px" }}
                                      />
                                    )}
                                    {it.label}
                                  </MenuItem>
                                ))}
                            </Menu>
                          )}
                          {!menu && (
                            <Menu
                              id={`menu-${person.id}`}
                              anchorEl={anchorEl}
                              open={open && selectedRow?.id === person.id} // Ensure only the clicked row's menu opens
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `button-${person.id}`,
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handlefunction(person.id, "approved");
                                  handleClose();
                                }}
                                disabled
                                style={{
                                  display:
                                    person.status === "approved"
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <CheckCircleOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                Approve
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handlefunction(person.id, "rejected");
                                  handleClose();
                                }}
                                disabled
                              >
                                {" "}
                                <ClearIcon style={{ marginRight: "5px" }} />
                                Reject
                              </MenuItem>
                            </Menu>
                          )}
                          {menu === "true" && (
                            <Menu
                              id={`menu-${person.id}`}
                              anchorEl={anchorEl}
                              open={open && selectedRow?.id === person.id} // Ensure only the clicked row's menu opens
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `button-${person.id}`,
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  navigate(path, {
                                    state: { data: person, edit2: true },
                                  });
                                }}
                              >
                                <DvrIcon style={{ marginRight: "5px" }} /> Show
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  navigate(path, {
                                    state: { data: person, edit2: false },
                                  });
                                }}
                              >
                                {" "}
                                <DriveFileRenameOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  handleDeleted(person.id, person.entity);
                                }}
                                disabled={person.deleted_at ? true : false}
                              >
                                {" "}
                                <DeleteOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                Delete
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  navigate(
                                    "/admin/consultant/verify_consultant",
                                    {
                                      state: { data: person, edit2: true },
                                    },
                                  );
                                  // handlechange("Approved", person.id,person.SK,person.PK);
                                }}
                                style={{
                                  display:
                                    person.approve_status === "Approved"
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <CheckCircleOutlineIcon
                                  style={{ marginRight: "5px" }}
                                />
                                verify{" "}
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  handlechange(
                                    "Rejected",
                                    person,
                                    // person.id,
                                    // person.SK,
                                    // person.PK
                                  );
                                }}
                              >
                                {" "}
                                <ClearIcon style={{ marginRight: "5px" }} />
                                Reject
                              </MenuItem>
                              {person.active ? (
                                <MenuItem
                                  onClick={() => {
                                    handleActive(false, person, "Consultant");
                                    handleClose();
                                  }}
                                >
                                  <RiNotificationOffLine
                                    style={{ marginRight: "5px" }}
                                  />
                                  Deactivate
                                </MenuItem>
                              ) : (
                                <MenuItem
                                  onClick={() => {
                                    handleActive(
                                      // person.id,
                                      // person.role,
                                      true,
                                      person,
                                      "Consultant",
                                      // person.SK,
                                      // person.PK
                                    );
                                    handleClose();
                                  }}
                                >
                                  <RiNotificationLine
                                    style={{ marginRight: "5px" }}
                                  />
                                  Activate
                                </MenuItem>
                              )}
                            </Menu>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              {loader && (
                <TableRow style={{ width: "100%" }}>
                  <TableCell
                    colSpan={12}
                    align="center"
                    style={{ height: "300px" }}
                  >
                    <CircularProgress
                      style={{ color: "var(--admin-page--color)" }}
                    />
                  </TableCell>
                </TableRow>
              )}
              {notfound && (
                <TableRow style={{ width: "100%" }}>
                  <TableCell
                    colSpan={12}
                    align="center"
                    style={{ height: "300px" }}
                  >
                    <h4>Data Not Found</h4>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="pagination">
          {/* <Typography>Total Pages: {Math.ceil(total / rowsPerPage)}</Typography> */}
          {APIdata && total > 0 ? (
            <Stack spacing={2}>
              <Pagination
                variant="outlined"
                shape="rounded"
                disabled={disable}
                count={Math.ceil(total / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                siblingCount={0}
                renderItem={(item) => {
                  // Always show first page
                  if (
                    item.page === page ||
                    item.page === page - 1 ||
                    item.type == "next"
                  ) {
                    return <PaginationItem {...item} />;
                  }
                  // Always show ellipsis at the end
                  if (item.type === "end-ellipsis") {
                    return <PaginationItem {...item} />;
                  }
                  // Hide all other page numbers and ellipses
                  // return <></>;
                }}
              />
            </Stack>
          ) : (
            <PaginationUI
              handleNext={handleNext}
              page={newPage.current}
              handlePrev={handlePrev}
            />
          )}
          <span className="totalpage">
            <select
              className="select"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <div
              className="page1"
              style={{
                color: "#1c1c1cec",
                paddingTop: "5px",
                marginLeft: "7px",
              }}
            >
              <h5>/page</h5>
            </div>
          </span>
        </div>
      </div>
      <Pop
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        cell={cell}
        headers={headers}
        showdata={showdata || []}
        id={data_id}
        setReload={setReload}
        credentials={credentials}
        balance_data={balance_data}
        Consultant_name={Consultant_name}
        PK_bank={BankPk}
        SK_bank={BankSk}
        credentialsData={credentialsData}
        data_id={data2_id}
      />
      <AdminPasswordModal
        openReset={openReset}
        setOpenReset={setOpenReset}
        showdata={showdata2 || []}
        password={password}
      />
    </div>
  );
}
